import FeatherIcon from "feather-icons-react"
import { useState } from "react";
import { GetCompanyData } from "src/graphql/company";
import { formatMoneyWithCurrency } from "src/utils/formatter";
import { DropdownToPayResume } from "./DropdownToPayResume";
import { sumDebtsForCompanies } from "../functions";

export const ResumeMonthToPay = ({ source, companyId, isToPay }) => {

  const sumDebts = sumDebtsForCompanies(source);
  const result = sumDebts[0]

  const [isExpanded, setIsExpanded] = useState(false);

  const { data } = GetCompanyData(companyId)

  const companyData = data?.Company

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };


  return (
    <>
      <div className="tw-bg-gray-100 tw-rounded-md tw-border-solid tw-border-[1px] tw-border-gray-200 tw-w-full tw-py-4 tw-px-6 tw-min-h-[83px]"
      //  onClick={toggleExpand}
      >
        <div className="tw-flex tw-justify-between" onClick={toggleExpand}>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <p className="tw-font-medium tw-text-lg tw-text-black !tw-p-0 !tw-m-0">{companyData?.alias || companyData?.name || ''}</p>
            <p className="tw-font-normal tw-text-gray-600 !tw-p-0 !tw-m-0 tw-capitalize">Monto total</p>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <p className="tw-font-medium tw-text-lg tw-text-black !tw-p-0 !tw-m-0">{formatMoneyWithCurrency(result.totalDebt + result.valid)}</p>
            <FeatherIcon icon={`${isExpanded ? 'chevron-down' : 'chevron-right'}`} size={20} className="tw-text-gray-600" strokeWidth={2.5} />
          </div>
        </div>
        <div className={`tw-transition-all tw-duration-300 tw-ease-in-out tw-mt-5 ${isExpanded ? 'tw-block' : 'tw-hidden'}`}>
          <div className="tw-bg-white tw-rounded-md tw-pb-2">
            <DropdownToPayResume
              data={result}
              source={source}
              companyId={companyId}
              isToPay={isToPay}
            />
          </div>
        </div>
      </div>
    </>
  )
}